/**
 * WordPress dependencies
 */
import { __, sprintf } from '@wordpress/i18n';
import { Modal, Button, TabPanel, SelectControl, Tooltip, Icon, Spinner, Card,
	CardHeader,
	CardBody,
	CardFooter } from '@wordpress/components';
import { useSelect, useDispatch, withSelect, withDispatch } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';
import apiFetch from '@wordpress/api-fetch';
import { useState, useEffect } from '@wordpress/element';
import { compose } from '@wordpress/compose';
import { autop } from '@wordpress/autop';

/**
 * External dependencies.
 */
import classnames from 'classnames';
import Masonry from 'react-masonry-component';
import LazyLoad from 'react-lazyload';

import '../../extensions/store/template-kit';
import AlertKitApply from './alert-kit-apply.js';

const CustomizerPanel = ( props ) => {
	const { applyKit, onClose, getKits } = props;

	const [ { showLoadingSpinner, showKitDetail, currentKit, isAlertKitApply, templateKits }, setState ] = useState( {
		showLoadingSpinner: true,
		showKitDetail: false,
		currentKit: {},
		isAlertKitApply: false,
		templateKits: [],
		// isTemplateReset: false,
	} );

	const updateState = ( data ) => {
		setState( ( prevState ) => {
			return {
				...prevState,
				...data,
			};
		} );
	};

	// const loadKists = ( reset = false ) => {
	// 	const kits = getKits( reset );
	// 	updateState( {
	// 		templateKits: kits,

	// 		isTemplateReset: false,
	// 	} );
	// };

	// const loadKists = async ( reset = false ) => {
	// 	return await select( 'gutenify/template-kit' ).getTemplateKits( reset );
	// };

	useEffect( () => {
		const kits = getKits();
		kits.then( ( res ) => {
			updateState( {
				showLoadingSpinner: false,
				templateKits: res,
			} );
		} );
	}, [ ] );

	// useEffect( () => {
	// 	updateState( {
	// 		showLoadingSpinner: false,
	// 	} );
	// }, [ templateKits ] );
	// console.log( templateKits );

	// useEffect( async () => {
	// 	if ( styleId ) {
	// 		await apiFetch( {
	// 			path: `/wp/v2/global-styles/${ styleId }`,
	// 		} ).then( ( data ) => {
	// 			console.log( data );
	// 		} ).catch( ( error ) => {
	// 			console.log( error );
	// 		} );
	// 	}
	// }, [ styleId ] );

	return <>
		<Modal
			className={ classnames(
				'gutenify-plugin-templates-modal',
				'gutenify-component-modal-hide-header'
			) }
			position="top"
			size="lg"
			onRequestClose={ () => {
				onClose();
			} }
			shouldCloseOnClickOutside={ false }
			// icon={ getIcon( 'plugin-templates' ) }
			// isFullScreen={ true }
			__experimentalHideHeader={ true }
		>
			<div className="components-modal__header">
				<div className="components-modal__header-heading-container">
					<h1
						id="components-modal-header-1"
						className="components-modal__header-heading"
					>
						{ ! showKitDetail && __( 'Gutenify Template Kits', '@@text_domain' ) }
						{ showKitDetail && templateKits && currentKit.title }
					</h1>
				</div>
				{ showLoadingSpinner ? (
					<div className="gutenify-plugin-templates-modal-loading-spinner">
						<Spinner />
					</div>
				) : (
					''
				) }

				<button
					type="button"
					aria-label="Close dialog"
					className="components-button components-icon-button"
					onClick={ () => {
						onClose();
					} }
				>
					<svg
						aria-hidden="true"
						role="img"
						focusable="false"
						className="dashicon dashicons-no-alt"
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 20 20"
					>
						<path d="M14.95 6.46L11.41 10l3.54 3.54-1.41 1.41L10 11.42l-3.53 3.53-1.42-1.42L8.58 10 5.05 6.47l1.42-1.42L10 8.58l3.54-3.53z" />
					</svg>
				</button>
			</div>
			<div className={ classnames(
				'gutenify-template-kit-browser-wrapper',
				showLoadingSpinner && 'gutenify-template-kit-browser-loading',
				showKitDetail && 'gutenify-template-kit-browser-has-kit-details'
			) }>
				<div className="gutenify-template-kit-browser-listing-area">
					{ ! showKitDetail && ( <Card className="gutenify-template-kit-browser-toolbar">
						<CardHeader>

							<>
								<span><strong>{ __( 'Total kits:' ) }</strong> { templateKits.length }</span>
								<Button isSecondary onClick={ () => {
									updateState( {
										showLoadingSpinner: true,
									} );
									const kits = getKits( true );
									kits.then( ( res ) => {
										updateState( {
											showLoadingSpinner: false,
											templateKits: res,
										} );
									} );
								} }><Icon icon="update" className="example-class" />Refresh</Button>
							</>

						</CardHeader>
					</Card> ) }
					<div className="gutenify-template-kit-browser-lists-wrapper">
						{ ! showKitDetail && templateKits && <Masonry
							className="gutenify-template-kit-browser-lists"
							elementType="ul"
							disableImagesLoaded={ false }
							updateOnEachImageLoad
							options={ {
								transitionDuration: 0,
							} }
						>
							{ templateKits.map( ( kit ) => {
								const withThumb = !! kit.thumbnail;
								let thumbAspectRatio = false;

								if ( kit.thumbnail_height && kit.thumbnail_width ) {
									thumbAspectRatio = kit.thumbnail_height / kit.thumbnail_width;
								}
								return <li
									className={ classnames(
										'gutenify-plugin-templates-list-item',
										withThumb
											? ''
											: 'gutenify-plugin-templates-list-item-no-thumb'
									) }
									key={ kit.kit_name }
								>
									<button onClick={ () => {
										updateState( {
											currentKit: kit,
											showKitDetail: true,
										} );
									} }>
										{ withThumb ? (
											<div className="gutenify-plugin-templates-list-item-image">
												{ thumbAspectRatio ? (
													<div
														className="gutenify-plugin-templates-list-item-image-sizer"
														style={ {
															paddingTop: `${ 100 * thumbAspectRatio }%`,
														} }
													/>
												) : (
													''
												) }
												<LazyLoad overflow offset={ 100 }>
													<img
														src={ kit.thumbnail }
														alt={ kit.title }
														width="100"
													/>
												</LazyLoad>
											</div>
										) : (
											''
										) }
										<span>{ kit.title }</span>
									</button>
								</li>;
							} ) }
						</Masonry> }

						{ showKitDetail && templateKits && <>
							<Card>
								<CardHeader>

									<Button onClick={ () => {
										updateState( {
											currentKit: {},
											showKitDetail: false,
										} );
									} } >
										<Icon icon="arrow-left-alt" className="example-class" />Back to listing
									</Button>

									<div className="gutenify-template-browser-button-group">
										{ currentKit.demo_link && <Button isSecondary href={ currentKit.demo_link } target="__blank"><Icon icon="welcome-view-site" />View Demo</Button> }
										{ showKitDetail && templateKits && <>
											<Button isPrimary onClick={ async () => {
												updateState( {
													isAlertKitApply: true,
												} );
											} } ><Icon icon="yes" />Apply Kit</Button>

											{ isAlertKitApply && <AlertKitApply onCancel={ () => {
												updateState( {
													isAlertKitApply: false,
												} );
											} } onApply={ async ( importOptions ) => {
												return await applyKit( currentKit, importOptions );
											} } kit={ currentKit } /> }
										</>
										}
									</div>
								</CardHeader>
								<CardBody>
									<div className="gutenify-template-kit-information-wrapper">
										<div dangerouslySetInnerHTML={ { __html: autop( currentKit.content ) } } className="gutenify-template-kit-information-content" />
										<div className="gutenify-template-kit-information-sidebar">
											<h3>{ __( 'Kit includes following:' ) }</h3>
											{ currentKit.kit_parts.length > 0 && <div>
												<h4>Template Parts</h4>
												<ul>
													{ currentKit.kit_parts.map( ( item ) => {
														const hasDemo = !! item.demo_link;
														return <li key={ `part-${ item.slug }` }>
															<Icon icon="yes" /> { hasDemo ? <a href={ item.demo_link } target="__blank">{ item.title }</a> : <span>{ item.title }</span> }
														</li>;
													} ) }
												</ul>
											</div> }

											{ currentKit.kit_templates.length > 0 && <div>
												<h4>Templates</h4>
												<ul>
													{ currentKit.kit_templates.map( ( item ) => {
														const hasDemo = !! item.demo_link;
														return <li key={ `part-${ item.slug }` }>
															<Icon icon="yes" /> { hasDemo ? <a href={ item.demo_link } target="__blank">{ item.title }</a> : <span>{ item.title }</span> }
														</li>;
													} ) }
												</ul>
											</div> }

											{ currentKit.kit_demo_pages.length > 0 && <div>
												<h4>Demo Pages</h4>
												<ul>
													{ currentKit.kit_demo_pages.map( ( item ) => {
														const hasDemo = !! item.demo_link;
														return <li key={ `part-${ item.slug }` }>
															<Icon icon="yes" /> { hasDemo ? <a href={ item.demo_link } target="__blank">{ item.title }</a> : <span>{ item.title }</span> }
														</li>;
													} ) }
												</ul>
											</div> }
											{ currentKit.kit_styles && <div>
												<h4>Style & Settings</h4>
												<ul>
													<li>
														<Icon icon="yes" /> Custom Settings & styles
													</li>
												</ul>
											</div> }
										</div>
									</div>
								</CardBody>
							</Card>
						</> }
					</div>
				</div>
			</div>

		</Modal>
	</>;
};
export default compose( [
	withSelect( ( select ) => {
		const getKits = ( reset = false ) => {
			return new Promise( function( resolve, reject ) {
				apiFetch( {
					path: '/gutenify/v1/get_template_kit/?reset=' + reset,
				} ).then( ( res ) => {
					resolve( res.response );
				} ).catch( ( error ) => {
					reject( error );
				} );
			} );
		};
		// const templateKits = select1( 'gutenify/template-kit' ).getTemplateKits( );
		// };
		// console.log( getKits() );
		const styleId = select( coreStore ).__experimentalGetCurrentGlobalStylesId();
		// const currentTheme = select1( coreStore ).getCurrentTheme();
		// const refreshKits = () => {
		// 	return select1( 'gutenify/template-kit' ).getTemplateKits( true );
		// };
		return {
			// templateKits,
			styleId,
			// currentTheme,
			// refreshKits,
			getKits,
		};
	} ),
	withDispatch( ( dispatch, props ) => {
		const { styleId } = props;
		const applyKit = ( selectedKit, importOptions ) => {
			// console.log( kit );
			const { activeParts,
				activeTemplates,
				activeDemoPages,
				// activeSettings,
				activeStyle } = importOptions;
			return new Promise( function( resolve, reject ) {
				apiFetch( {
					path: `/gutenify/v1/get_template_kit_data?id=${ selectedKit.id }&type=remote`,
				} ).then( ( response ) => {
					const kit = response.response;
					let kitParts = [];
					if ( kit.kit_parts ) {
						kitParts = kit.kit_parts.filter( ( item ) => {
							return activeParts.includes( item.slug );
						} );
					}

					let kitTemplates = [];
					if ( kit.kit_parts ) {
						kitTemplates = kit.kit_templates.filter( ( item ) => {
							return activeTemplates.includes( item.slug );
						} );
					}

					let kitDemoPages = [];
					if ( kit.kit_parts ) {
						kitDemoPages = kit.kit_demo_pages.filter( ( item ) => {
							return activeDemoPages.includes( item.slug );
						} );
					}

					apiFetch( {
						path: `/gutenify/v1/create_kit`,
						method: 'POST',
						data: {
							title: kit.title,
							name: kit.kit_name,
							template_parts: kitParts,
							templates: kitTemplates,
							demo_pages: kitDemoPages,
							styleId,
						},
					} ).then( ( response ) => {
						if ( activeStyle ) {
							apiFetch( {
								path: `/wp/v2/global-styles/${ styleId }`,
								method: 'POST',
								data: {
									styles: ( kit.kit_styles ),
								},
							} ).then( ( ) => {
								resolve( true );
							} ).catch( ( ) => {
								reject( false );
							} );
						} else {
							resolve( true );
						}
					} ).catch( ( ) => {
						reject( false );
					} );
				} ).catch( ( ) => {
					reject( false );
				} );
			} );
		};

		return {
			applyKit,
		};
	} ),
] )( CustomizerPanel );
